import { useState } from 'react';
import { ChevronDown, X } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import { Checkbox } from './ui/checkbox';
import { TESIS_TURU_OPTIONS, tesisTuruList, tesisTuruLabel } from '../utils/tesisTuru';

// Çoktan seçmeli Tesis Türü: onay kutulu açılır liste + seçilenler etiket (chip) olarak, tek tıkla kaldırılır.
// value: kod listesi (eski tek string de kabul edilir) → onChange(kodListesi)
export function TesisTuruSecici({ value, onChange, options = TESIS_TURU_OPTIONS, extraOptions = [], placeholder = 'Tesis türü seçin', testId = 'tesis-turu-secici', compact = false, disabled = false, className = '' }) {
  const [open, setOpen] = useState(false);
  const selected = tesisTuruList(value);
  const all = [...extraOptions, ...options];
  const known = new Set(all.map(o => o.value));
  const unknown = selected.filter(c => !known.has(c)).map(c => ({ value: c, label: tesisTuruLabel(c) }));
  const toggle = (code) => onChange(selected.includes(code) ? selected.filter(c => c !== code) : [...selected, code]);
  const maxChips = compact ? 2 : 6;
  const chips = selected.slice(0, maxChips);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild disabled={disabled}>
        <button type="button" role="combobox" aria-expanded={open} data-testid={testId}
          className={`w-full flex items-center justify-between gap-2 rounded-md border border-gray-700 bg-gray-800 text-white text-sm px-3 ${compact ? 'min-h-9 py-1' : 'min-h-10 py-1.5'} hover:bg-gray-750 disabled:opacity-50 ${className}`}>
          <div className="flex flex-wrap gap-1 flex-1 text-left">
            {selected.length === 0 && <span className="text-gray-500">{placeholder}</span>}
            {chips.map(code => (
              <span key={code} className="inline-flex items-center gap-1 rounded-full bg-blue-600/25 border border-blue-500/40 text-blue-100 text-xs px-2 py-0.5" data-testid={`${testId}-chip-${code}`}>
                {tesisTuruLabel(code)}
                {!disabled && <span role="button" aria-label="Kaldır" onClick={(e) => { e.stopPropagation(); toggle(code); }} className="hover:text-white" data-testid={`${testId}-remove-${code}`}><X className="w-3 h-3" /></span>}
              </span>
            ))}
            {selected.length > maxChips && <span className="text-xs text-gray-400 self-center">+{selected.length - maxChips}</span>}
          </div>
          <ChevronDown className="w-4 h-4 text-gray-400 shrink-0" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-72 p-1 bg-gray-800 border-gray-700 text-white max-h-80 overflow-y-auto" data-testid={`${testId}-menu`}>
        {[...all, ...unknown].map(o => (
          <label key={o.value} className="flex items-center gap-2 px-2 py-1.5 rounded hover:bg-gray-700 cursor-pointer text-sm" data-testid={`${testId}-opt-${o.value}`}>
            <Checkbox checked={selected.includes(o.value)} onCheckedChange={() => toggle(o.value)} className="border-gray-500 data-[state=checked]:bg-blue-600 data-[state=checked]:border-blue-600" />
            <span>{o.label}</span>
          </label>
        ))}
        <div className="flex items-center justify-between px-2 py-1.5 border-t border-gray-700 mt-1 text-xs">
          <span className="text-gray-400">{selected.length} seçili</span>
          <button type="button" onClick={() => onChange([])} className="text-red-400 hover:text-red-300" data-testid={`${testId}-clear`}>Temizle</button>
        </div>
      </PopoverContent>
    </Popover>
  );
}
